import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router.tsx";
import { SessionProvider } from "./lib/session.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { initAnalytics, trackPageView } from "./lib/analytics.ts";
import { AnalyticsIdentity } from "./components/AnalyticsIdentity.tsx";
import "./styles/dash.css";
import "./styles/global.css";

// Initialise Firebase Analytics once at app boot.
initAnalytics();

// Track every client-side navigation via the router's state stream.
router.subscribe((state) => {
  if (state.navigation.state === "idle") {
    trackPageView(state.location.pathname + state.location.search);
  }
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No #root element found");

// SessionProvider sits ABOVE the router so the auth-session subscription is held
// for the app's lifetime (one /get-session per load, not one per route remount).
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <SessionProvider>
        <AnalyticsIdentity />
        <RouterProvider router={router} />
      </SessionProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
